/*
 * © Copyright 2014 - 2022 Micro Focus or one of its affiliates.
 *
 * The only warranties for products and services of Micro Focus and its affiliates and licensors ("Micro Focus") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Micro Focus shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import React from 'react';
import ShowHidePassword from '../../../ShowHidePassword';
import {generateFormChangeHandler} from '../../../../utils/form-handler';
import {methodIds} from '../../../../data/MethodData';
import t from '../../../../i18n/locale-keys';

// Test several methods that only include a Password field. This includes:
// - Single-step doLogon methods: EMERG_PASSWORD, HOTP, PASSWORD, RADIUS, TOTP
// - Double-step doLogon methods (first doLogon sends OTP): EMAIL_OTP, SMS_OTP, VOICE_OTP
const doubleStepLogons = [methodIds.EMAIL_OTP, methodIds.SMS_OTP, methodIds.VOICE_OTP];

class PasswordOnlyTest extends React.PureComponent {
    constructor(props) {
        super(props);

        generateFormChangeHandler(this, {
            answer: ''
        });

        if (doubleStepLogons.indexOf(props.template.methodId) !== -1) {
            this.props.doTestLogon(null);
        }
    }

    clearForm() {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                answer: ''
            }
        }));
    }

    render() {
        return (
            <React.Fragment>
                <ShowHidePassword
                    autoFocus
                    name="answer"
                    onChange={this.handleChange}
                    placeholder={t.passwordLabel()}
                    value={this.state.form.answer}
                />
            </React.Fragment>
        );
    }
}

export default PasswordOnlyTest;
